// extracted by mini-css-extract-plugin
module.exports = {"ImageGallery":"ImageGallery_ImageGallery__DncjJ"};